<template>
  <v-dialog name="asd" v-model="modalComputed" persistent  max-width="780" v-if="produtoComputed !== undefined">
    <v-card>

      <v-toolbar flat color="accent">
        <v-btn icon @click="modalComputed = false">
          <v-icon>mdi-close</v-icon>
        </v-btn>
        <v-toolbar-title>C&oacute;digos de Barras - Produto {{ this.produtoComputed.cc_psr }}, {{ this.produtoComputed.nm_psr }}</v-toolbar-title>
      </v-toolbar>

      <v-card-text class="ma-0 pa-0">
        <v-container>
          <v-row>

            <v-col cols="12" xs="12" sm="12" md="12" lg="12" xl="12">

              <div v-if="itens.length === 0">
                <v-alert text type="info" color="primary">N&atilde;o h&aacute; c&oacute;digos de barras cadastradas para este produto</v-alert>
              </div>

              <v-simple-table class="mb-2" v-else>
                <template v-slot:default>
                  <thead>
                    <tr>
                      <th>Código</th>
                      <th width="30"></th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="item in itens" :key="item.id_reg">
                      <td>{{ item.cc_ean }}</td>
                      <td>
                        <v-tooltip left>
                          <template v-slot:activator="{ on }">
                              <v-btn depressed small fab color="primary" v-on="on" @click="deletar(item)">
                                <v-icon>mdi-delete</v-icon>
                              </v-btn>
                          </template>
                          <span>Deletar</span>
                        </v-tooltip>
                      </td>
                    </tr>
                  </tbody>
                </template>
              </v-simple-table>

              <v-card outlined>
                <v-card-text>
                  <v-form ref="form" @submit="inserir()" v-model="valid" :lazy-validation="lazy" v-on:submit.prevent>
                      <div class="d-flex flex-row mb-6">
                        <v-text-field v-model="ean.cc_ean" label="Código" :rules="validacao.cc_ean"></v-text-field>
                      </div>
                      <v-btn depressed outlined color="primary" type="submit">SALVAR</v-btn>
                  </v-form>
                </v-card-text>
              </v-card>

            </v-col>
          </v-row>
        </v-container>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>
<script>
export default {

  name: 'Ean',

  data() {
    return {

      valid: true,
      lazy:true,
      itens:[],

      ean: {
        cc_psr: undefined,
        cc_fil: undefined,
        cc_ean: undefined,
      },

      validacao: {
        cc_ean: [
          (v) => !!v || 'Requerido',
          (v) => /^\d+$/.test(v) || 'Formato inválido'
        ],
      },

      produtoTemp: undefined,
      modalTemp: undefined
    }
  },

  props: {

    produto: {
      required: true
    },

    modal: {
      required: true,
      type: Boolean
    },

  },

  methods: {

    listar() {
      this.itens = []
      if(this.produtoComputed !== undefined) {
        this.$store.dispatch('pesquisaEan', {size:9999, cc_fil: this.produtoComputed.cc_fil, cc_psr: this.produtoComputed.cc_psr}).then(resp => {
           resp.data.content.forEach(el => {
             this.itens.push(el)
           });
         }).catch()
      }
    },

    inserir() {
      if (this.$refs.form.validate()) {
        this.ean.cc_fil = this.produtoComputed.cc_fil
        this.ean.cc_psr = this.produtoComputed.cc_psr
        this.$store.dispatch('salvarEan', this.ean).then(() => {
          this.listar()
          this.resetarFormulario()
        }).catch()
      }
    },

    deletar(item) {
      this.$store.dispatch('deletarEan', item.id_reg).then(() => {
        this.listar()
      }).catch()
    },

    resetarFormulario(){
      this.$refs.form.reset()
    },
  },

  computed: {
    modalComputed :  {
      get: function() { 
        return this.modalTemp
      },
      set: function(value) {
        this.modalTemp = value
      }
    },
    produtoComputed: {
      get: function() { 
        return this.produtoTemp
      },
      set: function(value) {
        this.produtoTemp = value
      }
    }
  },

  mounted: function() {
    this.listar()
  },

  created: function() {

    this.modalComputed = this.modal
    this.produtoComputed = this.produto
    this.$emit('a')

  }

}
</script>